export function isNumberUptoTwoDecimalPoints(numberToTest)
{
    // https://stackoverflow.com/questions/10023845/regex-in-javascript-for-validating-decimal-numbers
    let regexp = /^\d+(\.\d{1,2})?$/;
    return regexp.test(numberToTest);
}